const musicLinksNL = {
    "view": {
        "table": {
            "title": "Uw muziekkoppelingenlijst",
            "column": {
                "releaseName": "Release Naam",
                "artists": "Artiesten",
                "owner": "Eigenaar",
                "created": "Gemaakt",
                "musicLink": "Muziekkoppeling",
                "action": "Actie"
            },
            "button": {
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "message": {
                "linkCopied": "Link gekopieerd naar klembord!"
            }
        },
        "modal": {
            "edit": {
                "header": "Bewerk {{musicLinkName}}?",
                "body": "Weet u zeker dat u deze muziekkoppeling wilt bewerken?"
            },
            "delete": {
                "header": "Verwijder {{musicLinkName}}?",
                "body": "Weet u zeker dat u deze muziekkoppeling wilt verwijderen?"
            }
        },
        "message": {
            "success": "Muziekkoppeling is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "mlAllowanceSpent": "U heeft uw muziekkoppelingstegoed verbruikt. Om meer muziekkoppelingen te maken, upgrade uw account of neem contact op met ons ondersteuningsteam.",
            "subscriptionFeatureUnavailable": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve uw abonnementsplan te <1>upgraden</1> om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "moduleAccessRestricted": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "add": {
        "title": "Voeg Muziekkoppeling Toe",
        "form": {
            "label": {
                "source": "Bron",
                "subUser": "Sub-gebruiker",
                "release": "Release",
                "artwork": "Artwork",
                "releaseName": "Release Naam",
                "upcEan": "UPC/EAN",
                "artistName": "Artiest Naam",
                "urlPart1": "Url deel1",
                "urlPart2": "Url deel2",
                "musicLinkUrl": "Uw muziekkoppeling URL is",
                "searchBy": "Zoeken Op",
                "upcNumber": "UPC Nummer",
                "storeReleaseUrl": "Winkel Release URL",
                "colorCustomisation": "Kleuraanpassing",
                "premadeColors": "Vooraf gemaakte Kleuren",
                "customColors": "Aangepaste Kleuren",
                "buttonStyle": "Knopstijl",
                "headerBackground": "Kopachtergrond",
                "singleColor": "Enkele Kleur",
                "gradient": "Gradiënt",
                "playerControlsColor": "Speler Bedieningselementen Kleur",
                "titleColor": "Titel Kleur",
                "descriptionColor": "Beschrijving Kleur",
                "buttonColor": "Knop Kleur",
                "buttonHoverColor": "Knop Hover Kleur",
                "buttonTextColor": "Knop Tekst Kleur"
            },
            "placeholder": {
                "subUser": "Selecteer Sub-gebruiker...",
                "release": "Selecteer Release",
                "releaseUpc": "Voer Release UPC/EAN Nummer in, bijv. 5055964352523",
                "releaseStoreUrl": "Voer Release Winkel Url in, bijv. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn of www.deezer.com/en/album/413370367",
                "urlPart1": "Selecteer Url Deel 1"
            },
            "help_text": {
                "subUser": "Opmerking: Gebruik deze dropdown alleen als u een muziekkoppeling wilt toevoegen voor een van uw sub-gebruikers, anders laat u deze ongewijzigd.",
                "release": "Opmerking: U kunt alleen releases selecteren die <strong>Gedistrubueerd</strong> zijn.",
                "releaseUpc": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen die al op Spotify of Deezer staat.",
                "releaseStoreUrl": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen die al op Spotify of Deezer staat."
            },
            "options": {
                "source": {
                    "existingRelease": "Bestaande Muziekkoppeling Release",
                    "externalRelease": "Externe Release"
                },
                "buttonStyle": {
                    "outlined": "Omlijnd",
                    "filled": "Gevuld"
                }
            },
            "button": {
                "reset": "Reset",
                "createNew": "Nieuwe Maken?",
                "submit": "Verzenden"
            },
            "validation": {
                "formInvalid": "Formulier kan niet worden verzonden! Vul alle velden in en controleer op fouten!",
                "storeUrlRequired": "{{store}} Url is vereist",
                "storeUrlValid": "Voeg een geldige {{store}} Url toe."
            }
        },
        "message": {
            "success": "Muziekkoppeling is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "fetchingReleaseDetails": "Release Details Ophalen..."
        }
    },
    "update": {
        "title": "Bewerk Muziekkoppeling",
        "form": {
            "label": {
                "source": "Bron",
                "release": "Release",
                "artwork": "Artwork",
                "releaseName": "Release Naam",
                "upcEan": "UPC/EAN",
                "artistName": "Artiest Naam",
                "urlPart1": "Url deel1",
                "urlPart2": "Url deel2",
                "musicLinkUrl": "Uw muziekkoppeling URL is",
                "searchBy": "Zoeken Op",
                "upcNumber": "UPC Nummer",
                "storeReleaseUrl": "Winkel Release URL",
                "colorCustomisation": "Kleuraanpassing",
                "premadeColors": "Vooraf gemaakte Kleuren",
                "customColors": "Aangepaste Kleuren",
                "buttonStyle": "Knopstijl",
                "headerBackground": "Kopachtergrond",
                "singleColor": "Enkele Kleur",
                "gradient": "Gradiënt",
                "playerControlsColor": "Speler Bedieningselementen Kleur",
                "titleColor": "Titel Kleur",
                "descriptionColor": "Beschrijving Kleur",
                "buttonColor": "Knop Kleur",
                "buttonHoverColor": "Knop Hover Kleur",
                "buttonTextColor": "Knop Tekst Kleur"
            },
            "placeholder": {
                "release": "Selecteer Release",
                "releaseUpc": "Voer Release UPC/EAN Nummer in, bijv. 5055964352523",
                "releaseStoreUrl": "Voer Release Winkel Url in, bijv. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn of www.deezer.com/en/album/413370367",
                "urlPart1": "Selecteer Url Deel 1"
            },
            "help_text": {
                "release": "Opmerking: U kunt alleen releases selecteren die <strong>Gedistrubueerd</strong> zijn.",
                "releaseUpc": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen die al op Spotify of Deezer staat.",
                "releaseStoreUrl": "Opmerking: Gebruik deze dropdown alleen als u een release wilt toevoegen die al op Spotify of Deezer staat."
            },
            "options": {
                "source": {
                    "existingRelease": "Bestaande Muziekkoppeling Release",
                    "externalRelease": "Externe Release"
                },
                "buttonStyle": {
                    "outlined": "Omlijnd",
                    "filled": "Gevuld"
                }
            },
            "button": {
                "reset": "Reset",
                "createNew": "Nieuwe Maken?",
                "submit": "Verzenden"
            },
            "validation": {
                "formInvalid": "Formulier kan niet worden verzonden! Vul alle velden in en controleer op fouten!",
                "storeUrlRequired": "{{store}} Url is vereist",
                "storeUrlValid": "Voeg een geldige {{store}} Url toe."
            }
        },
        "message": {
            "success": "Muziekkoppeling is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "fetchingReleaseDetails": "Release Details Ophalen..."
        }
    },
    "storeLinksRow": {
        "title": "Winkel Links",
        "label": {
            "store": "Winkel",
            "link": "Link"
        },
        "button": {
            "remove": "Verwijderen"
        },
        "model": {
            "addStore": {
                "header": "Voeg Winkel Toe",
                "body": "Kies de gewenste winkel uit de onderstaande lijst:",
                "option": {
                    "mainStores": "Hoofd Winkels",
                    "otherStores": "Andere Winkels"
                },
                "button": {
                    "add": "Voeg Winkel Toe",
                    "cancel": "Annuleren"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Voorbeeld Bestanden",
        "label": {
            "preview": "Voorbeeld",
            "artistName": "Artiest naam",
            "trackName": "Track naam"
        },
        "audioNotSupported": "Uw browser ondersteunt het audio-element niet."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Kies Muziekdienst",
            "track": "Track",
            "artist": "Artiest",
            "time": "Tijd",
            "others": "Anderen"
        },
        "button": {
            "play": "Afspelen"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Statistieken Ophalen voor Muziekkoppeling"
        },
        "topServices": {
            "title": "Top Diensten",
            "subtitle": "DOORKLIK PER DIENST",
            "table": {
                "column": {
                    "store": "Winkel",
                    "noOfVisits": "Totaal Bezoeken",
                    "noOfVisitsPct": "Totaal Bezoeken %"
                },
                "label": {
                    "otherStores": "Andere Winkels"
                }
            }
        },
        "topTracks": {
            "title": "Top Tracks",
            "subtitle": "DOORKLIK PER TRACK",
            "table": {
                "column": {
                    "trackName": "Track Naam",
                    "artistName": "Artiest Naam",
                    "noOfPlays": "Aantal Keer Gespeeld",
                    "noOfPlaysPct": "Aantal Keer Gespeeld %"
                }
            }
        },
        "topTerritories": {
            "title": "Top Gebieden",
            "subtitle": "DOORKLIK PER GEBIED",
            "table": {
                "column": {
                    "territory": "Gebied",
                    "noOfViews": "Aantal Weergaven",
                    "noOfViewsPct": "Aantal Weergaven %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Top Apparaattypen",
            "subtitle": "DOORKLIK PER APPARAATTYPE"
        },
        "topOperatingSystems": {
            "title": "Top Besturingssystemen",
            "subtitle": "DOORKLIK PER OS",
            "chart": {
                "label": {
                    "noOfViews": "Aantal Weergaven : ",
                    "operatingSystems": "Betriebssystem"
                }
            }
        },
        "topBrowsers": {
            "title": "Top Browsers",
            "subtitle": "DOORKLIK PER BROWSER",
            "table": {
                "column": {
                    "browser": "Browser",
                    "noOfViewsPct": "Aantal Weergaven (%)"
                }
            }
        }
    }
};

export default musicLinksNL;